import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {ChangeEmailTemplateModalProps} from '@Modals/change-email-template-modal/change-email-template-modal';

export * from './change-email-template-modal';

export const PANEL_ID = 'change-email-template-panel';

export const openChangeEmailTemplateModal = (props: ChangeEmailTemplateModalProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.CHANGE_EMAIL_TEMPLATE_MODAL,
      panelProps: props,
    })
  );
};
